import { Component, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs';
import { MODAL_BANNER_TYPE } from 'src/app/components/shared/modal/components/modal-frame/modal-error-banner/modal-error-banner.constants';
import { BUTTON_TYPES } from 'src/app/components/shared/modal/components/modal-frame/modal-frame.constants';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { SummaryService } from 'src/app/core/services/operations/summary/summary.service';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { DISPLAY_CONSTS } from './add-delivery-stop.constants';

@Component({
  selector: 'app-add-delivery-stop',
  templateUrl: './add-delivery-stop.component.html',
  styleUrls: ['./add-delivery-stop.component.scss'],
  standalone: false,
})
export class AddDeliveryStopComponent {
  readonly IMAGES = IMAGE_SRC;
  readonly CONSTS = DISPLAY_CONSTS;
  readonly BUTTON_TYPES = BUTTON_TYPES;

  showTrackingSearch = false;
  text = '';
  bannerType = signal(MODAL_BANNER_TYPE.NO_DATA_AVAILABLE);
  hasError = signal(false);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { date: string; routeId: string },
    private readonly dialogRef: MatDialogRef<AddDeliveryStopComponent>,
    private readonly summaryService: SummaryService,
    public commonUtils: CommonUtils,
  ) {}

  updateText($event: CustomEvent) {
    this.text = ($event.detail.value ?? '').toString().toUpperCase();
  }

  clear() {
    this.text = '';
  }

  onExit() {
    this.dialogRef.close();
  }

  onLeftClick() {
    this.hasError.set(false);
    if (this.showTrackingSearch) {
      this.showTrackingSearch = false;
    } else {
      this.showTrackingSearch = true;
    }
  }

  onRightClick() {
    this.hasError.set(false);
    if (this.showTrackingSearch) {
      this.summaryService
        .searchByTrackNum(this.text.trim().toUpperCase())
        .pipe(take(1))
        .subscribe((val) => {
          if (val.response === undefined) {
            this.hasError.set(true);
          } else {
            this.dialogRef.close({
              trackingNumData: val.response,
              trackNumSearch: true,
              customer: false,
            });
          }
        });
    } else {
      this.dialogRef.close({
        trackingNumData: null,
        trackNumSearch: false,
        customer: true,
      });
    }
  }
}
